import React from "react";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import ForumIcon from "@mui/icons-material/Forum";
import formatarHora from "./formatarHora";
import "./styles.css";

const MINUTOS_JANELA_DE_AVISO = 5;

const FasesTuboBanhoMaria = {
  aguardando: "aguardando",
  avisoPreRemocao: "avisoPreRemocao",
  remocaoImediata: "remocaoImediata",
  removido: "removido",
};

function obterFaseTuboBanhoMaria(previstoRemocaoEm, tempoAgora) {
  const minutosRestantes =
    (new Date(previstoRemocaoEm).getTime() - tempoAgora.getTime()) / 60000;
  if (minutosRestantes > MINUTOS_JANELA_DE_AVISO)
    return FasesTuboBanhoMaria.aguardando;
  if (minutosRestantes > 0) return FasesTuboBanhoMaria.avisoPreRemocao;
  return FasesTuboBanhoMaria.remocaoImediata;
}

export default function CardAmostra({ amostra, tempoAgora, onRemoverClick }) {
  const isFinalizado = amostra.status === "removido";
  const pacienteNome = `${amostra.pacienteNome ?? ""}`;

  const fase = isFinalizado
    ? FasesTuboBanhoMaria.removido
    : obterFaseTuboBanhoMaria(amostra.previstoRemocaoEm, tempoAgora);
  const emAlertaRemocao =
    !isFinalizado &&
    (fase === FasesTuboBanhoMaria.avisoPreRemocao ||
      fase === FasesTuboBanhoMaria.remocaoImediata);
  const podeRemover = !isFinalizado;

  return (
    <button
      type="button"
      disabled={!podeRemover}
      className={`card-amostra-stack${podeRemover ? " card-amostra--clicavel" : ""}`}
      onClick={() => onRemoverClick?.(amostra)}
    >
      <span
        className={`card-amostra-corpo${isFinalizado ? " card-amostra-corpo--finalizado" : ""}${
          emAlertaRemocao ? " card-amostra-corpo--com-alerta" : ""
        }${
          fase === FasesTuboBanhoMaria.avisoPreRemocao
            ? " card-amostra-corpo--aviso"
            : ""
        }${
          fase === FasesTuboBanhoMaria.remocaoImediata
            ? " card-amostra-corpo--urgente"
            : ""
        }`}
      >
        <span className="card-amostra-cabecalho">
          <span className="card-amostra-codigo-biomeriuex">
            {amostra.biomeriuex || "—"}
          </span>
          <span className="card-amostra-paciente" title={pacienteNome || "—"}>
            Paciente: {pacienteNome || "—"}
          </span>
          <span className="card-amostra-codigo-tubo">
            Tubo: {amostra.codigoTubo || "—"}
          </span>
        </span>

        <span className="card-amostra-metas">
          <span className="card-amostra-meta card-amostra-meta--relogio">
            <span className="card-amostra-meta-inicio">
              <AccessTimeIcon
                className="card-amostra-meta-icone"
                sx={{ fontSize: 12 }}
              />
              <span className="card-amostra-meta-rotulo">ADICIONADO</span>
            </span>
            <span className="card-amostra-meta-hora">
              {formatarHora(amostra.inseridoEm)}
            </span>
          </span>

          <span className="card-amostra-meta card-amostra-meta--sino">
            <span className="card-amostra-meta-inicio">
              <NotificationsActiveIcon
                className="card-amostra-meta-icone"
                sx={{ fontSize: 12 }}
              />
              <span className="card-amostra-meta-rotulo">
                {isFinalizado ? "REMOVIDO" : "REMOVER"}
              </span>
            </span>
            <span className="card-amostra-meta-hora">
              {isFinalizado
                ? amostra.removidoEm
                  ? formatarHora(amostra.removidoEm)
                  : "—"
                : formatarHora(amostra.previstoRemocaoEm)}
            </span>
          </span>
        </span>
      </span>

      {emAlertaRemocao && (
        <span
          className={
            fase === FasesTuboBanhoMaria.avisoPreRemocao
              ? "card-amostra-alerta card-amostra-alerta--aviso"
              : "card-amostra-alerta card-amostra-alerta--urgente"
          }
        >
          <ForumIcon
            sx={{ fontSize: 13 }}
            className="card-amostra-alerta-icone"
            aria-hidden
          />
          <span className="card-amostra-alerta-texto">
            {fase === FasesTuboBanhoMaria.avisoPreRemocao
              ? "Em breve o tubo deve ser removido do banho!"
              : "Hora de remover o tubo do banho!"}
          </span>
        </span>
      )}
    </button>
  );
}
